import React, {Fragment, useEffect, useState} from 'react'
import "./AlertFloorMap.css"
import IncidentCard from './incident/IncidentCard';
import {GoogleMap, Marker, useJsApiLoader} from "@react-google-maps/api";
import {Constants} from "../Constants";


function AlertFloorMap() {

    const [alertData] = useState([
        {
            name: 'Missing Helmet',
            id: 1,
            image: 'alert_icon.svg',
            capture_image: 'Missing Helmet1.png',
            capture_video: 'Missing Safety Helmet1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '74', y: '196', lat: 37.7687885, lng: -117.5898607},
            label: 'Tower 3, Zone 1',
            operator: 'Karen Chilton',
            work_type: 'Blasting',
            alert_type_level: 'Safety Infraction | Severity Level - 2 | Cam#DID1',
            alert_date_time: '25-02-2025 | 07:00 AM',

        },
        {
            name: 'Missing Safety Vest',
            id: 2,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Vest1.png',
            capture_video: 'Missing Safety Vest1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '-69', y: '275',lat: 37.7787885, lng: -117.558607},
            label: 'Mining Area, Zone 1',
            operator: 'Fed Chilton',
            work_type: 'Inspection',
            alert_type_level: 'Human Infraction | Severity Level - 3 | Cam#DID2',
            alert_date_time: '25-02-2025 | 08:15 AM',


        },
        {
            name: 'Missing Safety Goggles',
            id: 3,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Goggles1.png',
            capture_video: 'Missing Safety Goggles1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '-127', y: '374',lat: 37.7887885, lng: -117.5598607},
            label: 'Tower 2, Zone 1',
            operator: 'Peter Bishop',
            work_type: 'Blasting',
            alert_type_level: 'Safety Infraction | Severity Level - 2 | Cam#DID3',
            alert_date_time: '25-02-2025 | 09:00 AM',
        },
        {
            name: 'Missing Helmet',
            id: 4,
            image: 'alert_icon.svg',
            capture_image: 'Missing Helmet1.png',
            capture_video: 'Missing Safety Helmet1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '74', y: '196',lat: 37.7687885, lng: -117.5798607},
            label: 'Tower 3, Zone 1',
            operator: 'Peter Bishop',
            work_type: 'Blasting',
            alert_type_level: 'Safety Infraction | Severity Level - 2 | Cam#DID1',
            alert_date_time: '02-11-2024 | 07:00 AM',

        },
        {
            name: 'Missing Safety Shoes',
            id: 5,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Shoes1.png',
            capture_video: 'Missing Safety Shoes1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '96', y: '481',lat: 37.7787885, lng: -117.5898607},
            label: 'Tower 2, Zone 3',
            operator: 'Jack Fred',
            work_type: 'Loading',
            alert_type_level: 'Human Infraction | Severity Level - 3 | Cam#DID2',
            alert_date_time: '02-11-2024 | 09:25 PM',

        },
        {
            name: 'Missing Safety Gloves',
            id: 6,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Gloves1.png',
            capture_video: 'Missing Safety Gloves1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '4', y: '513',lat: 37.7787885, lng: -117.5698607},
            label: 'Tower 3, Zone 2',
            operator: 'Pannola Van',
            work_type: 'Drilling',
            alert_type_level: 'Safety Infraction | Severity Level - 2 | Cam#DID9',
            alert_date_time: '25-02-2025 | 08:00 PM',
        },

        {
            name: 'Missing Safety Vest',
            id: 7,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Vest1.png',
            capture_video: 'Missing Safety Vest1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '85', y: '275',lat: 37.7787885, lng: -117.5499607},
            label: 'Mining Area, Zone 1',
            operator: 'John Nathan',
            work_type: 'Inspection',
            alert_type_level: 'Human Infraction | Severity Level - 3 | Cam#DID2',
            alert_date_time: '02-11-2024 | 08:15 AM',


        },
        {
            name: 'Missing Safety Shoes',
            id: 8,
            image: 'alert_icon.svg',
            capture_image: 'Missing Safety Shoes1.png',
            capture_video: 'Missing Safety Shoes1.mp4',
            cp_image: 'sm-cp-img.png',
            loc: {x: '96', y: '581',lat: 37.7687885, lng: -117.5698607},
            label: 'Tower 2, Zone 3',
            operator: 'Wesly Tim',
            work_type: 'Loading',
            alert_type_level: 'Human Infraction | Severity Level - 3 | Cam#DID2',
            alert_date_time: '25-02-2025 | 09:25 PM',

        },
    ]);
    const [showIncidentCard, setShowIncidentCard] = React.useState(false);

    const [currentIncidentXPostion, setCurrentIncidentXPostion] = React.useState(0);
    const [currentIncidentYPostion, setCurrentIncidentYPostion] = React.useState(0);
    const [activeIncident, setActiveIncident] = React.useState();


    const currentIncidentPostion = (e) => {
        setCurrentIncidentXPostion(e.pageX);
        setCurrentIncidentYPostion(e.pageY);
    }

    const handleIncidentCard = (e,incident) => {
        currentIncidentPostion(e);
        if (activeIncident?.id === incident?.id && showIncidentCard) {
            setShowIncidentCard(false);
        } else {
            setShowIncidentCard(true);
            setActiveIncident(incident);
        }
    }

    useEffect(() => {
        const el = document.getElementsByClassName('AlertFloorMap')[0];
        const observer = new window.IntersectionObserver(([entry]) => {
            if (entry.isIntersecting) {
                return
            }
            setShowIncidentCard(false);
        }, {
            root: null,
            threshold: 0.1, // set offset 0.1 means trigger if atleast 10% of element in viewport
        })

        observer.observe(el);

    }, []);

    const [center] = useState({
        lat: 37.7687885,
        lng: -117.5698607,
    });
    const { isLoaded } = useJsApiLoader({
        id: 'google-map-script',
        googleMapsApiKey: Constants.MAP_API_KEY,
    })

    const [, setMap] = React.useState(null)
    const onLoad = React.useCallback(function callback(map) {
        // This is just an example of getting and using the map instance!!! don't just blindly copy!
        const bounds = new window.google.maps.LatLngBounds(center)
        if(!map) {
            map.fitBounds(bounds)
            setMap(map)
        }
    }, [center])

    const onUnmount = React.useCallback(function callback(map) {
        setMap(null)
    }, [])
    const containerStyle = {
        width: 'auto',
        height: '400px',
    }

    return (
        <>
            {activeIncident && showIncidentCard && <IncidentCard x={currentIncidentXPostion} y={currentIncidentYPostion} activeIncident={activeIncident} handleParentClose={handleIncidentCard} />}
            <div className='floor-container AlertFloorMap'>
                {isLoaded && <GoogleMap
                    mapContainerStyle={containerStyle}
                    center={center}
                    zoom={12}
                    onLoad={onLoad}
                    onUnmount={onUnmount}
                >
                    <>
                        {alertData.map((incident, key) =>
                                <Fragment key={key}>
                                    <Marker icon={require(`../images/${incident.image}`)}
                                            onClick={(e) => handleIncidentCard(e, incident)}
                                            position={{lat: incident.loc.lat, lng: incident.loc.lng}}
                                            // position={{
                                            //     lat: 37.7687885 + getRandomNumber(),
                                            //     lng: -117.5698607 + getRandomNumber()
                                            // }}
                                    />
                                </Fragment>
                            // <img src={}
                            //      alt=""
                            //      className='wk-alert'
                            //      key={key}
                            //      style={{top: incident.loc.x + 'px', left: incident.loc.y + 'px'}}
                            //      onClick={(e) => handleIncidentCard(e, incident)}
                            // />
                        )}
                    </>
                </GoogleMap>}
                {/*// <div className="floor-map">*/}
                {/*//     <div className="workers-alert">*/}
                {/*//*/}
                {/*//     </div>*/}
                {/*//*/}
                {/*//*/}
                {/*//     /!*<div className="inner-floor">*!/*/}
                {/*//     /!*    <img src={flrmap} alt="" />*!/*/}
                {/*//     /!*</div>*!/*/}
                {/*//*/}
                {/*// </div>*/}
            </div>
        </>
    )
}

export default AlertFloorMap
